export default __webpack_public_path__ + "static/media/safari_setting_partial_4.61b44546.png";